import React, { useState } from 'react';
import stockService from '../../services/stockService';
import { StockCreateRequestDTO } from '../../types/stock';

interface Props {
  onClose?: () => void;
  onSuccess?: () => void;
}

const StockCreateForm: React.FC<Props> = ({ onClose, onSuccess }) => {
  const [produtoId, setProdutoId] = useState('');
  const [quantidadeAtual, setQuantidadeAtual] = useState<number>(0);
  const [quantidadeMinima, setQuantidadeMinima] = useState<number>(0);
  const [quantidadeMaxima, setQuantidadeMaxima] = useState<number>(0);
  const [quantidadeReservada, setQuantidadeReservada] = useState<number>(0);
  const [localizacao, setLocalizacao] = useState<string>('');
  const [observacoes, setObservacoes] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const validate = (): string | null => {
    if (!produtoId) return 'Produto é obrigatório';
    if (quantidadeAtual < 0) return 'Quantidade atual não pode ser negativa';
    if (quantidadeMinima < 0) return 'Quantidade mínima não pode ser negativa';
    if (quantidadeMaxima < 0) return 'Quantidade máxima não pode ser negativa';
    if (quantidadeReservada < 0) return 'Quantidade reservada não pode ser negativa';
    if (quantidadeMinima > quantidadeMaxima) return 'Mínimo não pode ser maior que máximo';
    return null;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const msg = validate();
    if (msg) { setError(msg); return; }
    setLoading(true);
    setError(null);
    const payload: StockCreateRequestDTO = {
      produtoId,
      quantidadeAtual,
      quantidadeMinima,
      quantidadeMaxima,
      quantidadeReservada,
      localizacao: localizacao || undefined,
      observacoes: observacoes || undefined,
    };
    try {
      await stockService.createStock(payload);
      if (onSuccess) onSuccess();
      if (onClose) onClose();
    } catch (err: any) {
      setError(err?.message ?? 'Erro ao criar estoque');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ minWidth: 360 }}>
      <h3 style={{ marginBottom: 16 }}>Criar Estoque</h3>
      {error && (
        <div style={{ color: '#b00020', marginBottom: 12 }}>{error}</div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <div>
          <label>Produto ID</label>
          <input
            value={produtoId}
            onChange={(e) => setProdutoId(e.target.value)}
            placeholder="ID do produto"
            className="input"
            required
          />
        </div>
        <div>
          <label>Localização</label>
          <input
            value={localizacao}
            onChange={(e) => setLocalizacao(e.target.value)}
            placeholder="Ex.: Depósito A"
            className="input"
          />
        </div>
        <div>
          <label>Quantidade Atual</label>
          <input
            type="number"
            min={0}
            value={quantidadeAtual}
            onChange={(e) => setQuantidadeAtual(Number(e.target.value))}
            className="input"
          />
        </div>
        <div>
          <label>Reservado</label>
          <input
            type="number"
            min={0}
            value={quantidadeReservada}
            onChange={(e) => setQuantidadeReservada(Number(e.target.value))}
            className="input"
          />
        </div>
        <div>
          <label>Mínimo</label>
          <input
            type="number"
            min={0}
            value={quantidadeMinima}
            onChange={(e) => setQuantidadeMinima(Number(e.target.value))}
            className="input"
          />
        </div>
        <div>
          <label>Máximo</label>
          <input
            type="number"
            min={0}
            value={quantidadeMaxima}
            onChange={(e) => setQuantidadeMaxima(Number(e.target.value))}
            className="input"
          />
        </div>
      </div>

      <div style={{ marginTop: 12 }}>
        <label>Observações</label>
        <textarea
          value={observacoes}
          onChange={(e) => setObservacoes(e.target.value)}
          className="input"
          rows={3}
        />
      </div>

      <div style={{ marginTop: 16, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <button type="button" className="btn btn-outline" onClick={onClose} disabled={loading}>Cancelar</button>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Salvando...' : 'Salvar'}
        </button>
      </div>
    </form>
  );
};

export default StockCreateForm;